import styled from '@emotion/styled';

export const RoomContainer = styled.div`
    min-height: 100vh;

    .room {
        position: relative;
        width: 100%;
        background: #e6eeed;
        min-height: 100vh;
        padding-bottom: 12vh;
        display: flex;

        h2 {
            font-weight: 300;
            text-align: center;
        }
    }
    .controllersDiv {
        position: fixed;
        bottom: 0;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 2rem 1rem 1rem 1rem;

        min-height: 8vh;
        .controls {
            background: white;
            box-shadow: 1px 4px 7px #424242;
            border-radius: 1000px;
            display: flex;
            justify-content: space-evenly;
            align-items: center;
            padding: 1rem 2rem;
        }
        .mainControls {
            flex: 0;
        }
        .sideControls {
            flex: 0;
        }
        .Btn {
            width: 50px;
            height: 50px;
            border: #e3e3e3 2px solid;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 1000px;
            cursor: pointer;
            transition: background-color 200ms;
            background-color: #f8f8f8;
            margin: 0 0.5rem;
            :hover {
                background-color: #e3e3e3;
            }
        }
    }

    @media (max-width: 600px) {
        .room {
            padding-bottom: 14vh;
        }
        .controllersDiv {
            padding: 0.75rem;
            gap: 0.5rem;

            .controls {
                padding: 0.7rem 0.9rem;
                max-width: calc(100% - 6px);
            }
            .mainControls {
                flex: 1;
            }
            .sideControls {
                flex: 0;
                max-width: none;
            }
            .Btn {
                width: 42px;
                height: 42px;
                margin: 0 0.35rem;
            }
        }
    }
`;
